export enum RegistrationPortalEnum {
  klarda_partner = "klarda_partner",
  invest_in_klarda = "invest_in_klarda",
  new_project = "new_project",
}

export enum PurposeType {
  Advertising = "adversising",
  Investment_Opportunity = "investment_opportunity",
  General_Inquiry = "general_inquiry",
  Product_Technical_Support = "product_technical_support",
  Partnership = "partnership",
  Report_Feedback = "report_fedback",
}

export enum CategoryType {
  Blockchain_Protocol = "blockchain_protocol",
  Crypto_Exchange = "crypto_exchange",
  DeFi_Project = "defi_project",
  NFT_Metaverse = "nft_metaverse",
  Gaming_GameFi = "Gaming_gamefi",
  Venture_Capital_Investor = "venture_capital_investor",
  Event_Organizer = "event_organizer",
  Media_Content_Creator = "media_content_creator",
  Community_DAO = "community_dao",
  Developer_Tech_Provider = "developer_tech_provider",
  Others = "others",
}

export interface IRegistrationPortalPayload {
  name: string;
  type: RegistrationPortalEnum;
  description: string;
  website: string;
  country: string;
  first_name: string;
  last_name: string;
  email: string;
  position: string;
  phone?: string;
  telegram?: string;
  twitter: string;
  linkedin?: string;
  message?: string;
  category?: CategoryType;
  purpose?: PurposeType;
}
